import { Injectable, inject } from '@angular/core';
import { Client } from '@df/core/service/client';
import { DfEventService } from '@df/core/service/df-event';
import omit from 'lodash-es/omit';
import { Gtm } from './../event/gtm.event';

@Injectable({
    providedIn: 'root'
})
export class GtmDlService {
    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Client
     */
    private client = inject(Client);

    /**
     * Active only for browser (not in universal or prerender)
     */
    private readonly isEnabled = typeof window !== 'undefined' && !this.client.isPrerender && !this.client.isBot;

    /**
     * Dispatch GTM Event
     */
    async dispatch(eventData: Gtm.EventData) {
        if (!this.isEnabled) {
            return;
        }

        return this.dfEventService.dispatch({
            id: 'dfGtmEvent',
            data: {
                eventData
            },
            action: data => {
                const eventData = omit(data.eventData, 'triggerContext');

                if (!('event_data' in eventData)) {
                    eventData['event_data'] = null;
                } else {
                    window.dataLayer.push({ event_data: null }); // Clear the previous ecommerce object.
                }

                if ((eventData as Partial<Gtm.Ecommerce.EventData>).ecommerce) {
                    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                }

                if ('content' in eventData) {
                    window.dataLayer.push({ content: null });
                }

                window.dataLayer.push(eventData);
            }
        });
    }
}
